import React from 'react';
import { clsx } from 'clsx';
interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  variant?: 'default' | 'brawn' | 'brains';
  label?: string;
}
export function Input({
  className,
  variant = 'default',
  label,
  ...props
}: InputProps) {
  const baseStyles = 'w-full bg-black/50 border-2 px-4 py-3 text-white placeholder-white/30 focus:outline-none transition-colors rounded-sm';
  const variants = {
    default: 'border-white/20 focus:border-white',
    brawn: 'border-orange-900/50 focus:border-orange-500 text-orange-50 font-bold text-xl',
    brains: 'border-cyan-900/50 focus:border-cyan-500 text-cyan-50 font-mono'
  };
  return <div className="w-full" data-id="element-235">
      {label && <label className={clsx('block mb-2 text-sm font-bold uppercase tracking-wider', variant === 'brawn' ? 'text-orange-500' : variant === 'brains' ? 'text-cyan-500' : 'text-gray-400')} data-id="element-236">
          {label}
        </label>}
      <input className={clsx(baseStyles, variants[variant], className)} {...props} data-id="element-237" />
    </div>;
}